import {z} from 'zod';

// BST-10541: one competitor brand's point on the single-aspect scatter
// (x = tonality index, y = mentions). Mirrors the reviews `CompetitorAspectPoint`.
const competitorByAspectPointSchema = z.object({
    brandId: z.number(),
    brandName: z.string(),
    tonalityIdx: z.number(),
    mentions: z.number(),
});

export type CompetitorByAspectPointType = z.infer<typeof competitorByAspectPointSchema>;

export const competitorByAspectPointListSchema = competitorByAspectPointSchema.array();
